import {
    get,
    post,
    execute
} from "../axios";

/**
 * 获取个人信息接口
 * @param {} 
 * @return {Promise} 
 */
export const GetSimpleUserInfo = data => execute('api/v1/UserInfo/GetSimpleUserInfo', data)

// 新需求和预渲染冲突 预渲染不会请求接口 最简单接口实现
export const CheckEShopLogin = data => execute('eshopapi/v1/Home/CheckEShopLogin', data)

/**
 * 更新个人信息接口
 * @param {data} 
 * @return {Promise} 
 */
export const UpdateConsumerInfo = data => execute('eshopapi/v1/ShopConsumer/UpdateConsumerInfo', data)
/**
 * 获取平台个人信息
 * @param {} 
 * @return {Promise} 
 */
export const GetUserByPlat = () => execute('api/v1/UserInfo/GetUserInfo')

/**
 * 新增收货地址接口
 * @param {data} 
 * @return {Promise} 
 */
export const AddAddress = data => execute('eshopapi/v1/DeliveryAddr/Add', data)
/**
 * 更新收货地址接口
 * @param {data} 
 * @return {Promise} 
 */
export const UpdateAddress = data => execute('eshopapi/v1/DeliveryAddr/Update', data)
/**
 * 删除收货地址接口
 * @param {data} 
 * @return {Promise} 
 */
export const DelAddress = data => execute('eshopapi/v1/DeliveryAddr/Delete', data)
/**
 * 设置当前收货地址为默认地址接口
 * @param {data} 
 * @return {Promise} 
 */
export const SetDefaultAddress = data => execute('eshopapi/v1/DeliveryAddr/SetDefault', data)
/**
 * 获取收货地址（分页）列表接口
 * @param {data} 
 * @return {Promise} 
 */
export const GetAddrList = data => execute('eshopapi/v1/DeliveryAddr/GetSearchPageData', data)
/**
 * 获取微信绑定信息二维码
 * @param {} 
 * @return {Promise} 
 */
export const GetWechatQrCode = () => execute('api/v1/UserInfo/GetWechatBindQrCode')
/**
 * 获取绑定帐号信息
 * @param {data} 
 * @return {Promise} 
 */
export const GetBindUserInfo = data => execute('api/v1/UserInfo/GetWechatBindUserInfo', data)
/**
 * 用户绑定微信帐号接口，暂时没有使用，使用的是url，get方式
 * @param {data} 
 * @return {Promise} 
 */
export const UserBindWechat = data => execute('api/v1/UserInfo/UserBindWechat', data)
/**
 * 解除微信帐号绑定接口
 * @param {} 
 * @return {Promise} 
 */
export const UnBindWechat = () => execute('api/v1/UserInfo/UnBindWechat')
/**
 * 获取商家加盟验证码接口
 * @param {data} 
 * @return {Promise} 
 */
export const SendVerCodeRegister = data => execute('eshopapi/v1/BusinessJoinReg/SendVerCode_Register', data)
/**
 * 提交商家加盟登记接口
 * @param {data} 
 * @return {Promise} 
 */
export const SubmitRegister = data => execute('eshopapi/v1/BusinessJoinReg/SubmitRegister', data)
/**
 * 手机号加盟校验接口
 * @param {data} 
 * @return {Promise} 
 */
export const RegisterCheck = data => execute('eshopapi/v1/BusinessJoinReg/RegisterCheck', data)
/**
 * 加盟获取品牌
 * @param {data} 
 * @return {Promise} 
 */
export const GetBusinessList = data => execute('eshopapi/v1/BusinessJoinReg/GetBusinessJoinSerieList', data)

// 上传临时图片凭证
export const UploadTempImage = data => execute('eshopapi/v1/BusinessInvitation/UploadTempImage', data)
// 邀约商家
export const AddBusinessInvitation = data => execute('eshopapi/v1/BusinessInvitation/Add', data)
// 邀约客户
export const AddCustomerInvitation = data => execute('eshopapi/v1/CustomerInvitation/Add', data)
// 获取邀约活动的信息
export const GetActiveInfo = data => execute('eshopapi/v1/CustomerInvitation/GetActiveInfo', data)
// 微信h5分享，获取信息
export const GetWxActiveShareAuthInfo = data => execute('eshopapi/v1/CustomerInvitation/GetWxActiveShareAuthInfo', data)